const config = {
    homePage: {
        meta: {
            en: {
                title: "Sports Betting | Live Betting | Slots | Live Casino | Danobet",
                description: "Enjoy high-odds sports betting with Danobet. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Spor Bahisleri | Canlı Bahisler | Slotlar | Canlı Casino | Danobet",
                description: "Danobet Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. Danobet ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    signUpPage: {
        meta: {
            en: {
                title: "Sports Betting | Live Betting | Slots | Live Casino | Danobet",
                description: "Enjoy high-odds sports betting with Danobet. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Spor Bahisleri | Canlı Bahisler | Slotlar | Canlı Casino | Danobet",
                description: "Danobet Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. Danobet ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    livePage: {
        meta: {
            en: {
                title: "Live Betting | Danobet",
                description: "Join Danobet, the best betting site with the widest live betting variety, the highest live betting odds, and the most live matches, and win!",
                keywords: "live betting, live betting site, best live betting, most trusted live betting",
            },
            tr: {
                title: "Canlı Bahis | Danobet",
                description: "Canlı bahis alanında en çok canlı bahis çeşiti, en yüksek canlı bahis oranlar ve en çok canlı bahis karşılaşma ile en iyi bahis sitesi olan Danobet'e gelin, kazanın!",
                keywords: "canlı bahis, canlı bahis sitesi, en iyi canlı bahis, en güvenilir canlı bahis",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    sportPage: {
        meta: {
            en: {
                title: "Sports Betting | Danobet",
                description: "Bet on football, basketball, tennis, volleyball, handball, and all other sports with high odds at Danobet!",
                keywords: "sports betting, sports bets, football betting, basketball betting",
            },
            tr: {
                title: "Spor Bahisleri | Danobet",
                description: "Futbol, basketbol, tenis, voleybol ve hentbol gibi tüm spor branları için oynana bahis çeşitleri ve diğer tüm spor bahisleri, yüksek oranlar ile Danobet’de!",
                keywords: "spor bahisleri, spor bahis, futbol bahisleri, basketbol bahisleri",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    casinosPage: {
        meta: {
            en: {
                title: "Live Casino | Danobet",
                description: "Play popular casino games like roulette, blackjack, baccarat, and casino hold'em with live streams in the Danobet live casino lobby!",
                keywords: "live casino, live roulette, live blackjack, live baccarat, live turkish roulette, live holdem",
            },
            tr: {
                title: "Canlı Casino | Danobet",
                description: "Rulet, blackjack, baccarat, casino hold’em gibi popüler casino oyunlarını canlı yayın aktarımları ile Danobet’in canlı casino salonunda oynayın!",
                keywords: "canlı casino, canlı rulet, canlı blackjeack, canlı baccarat, canlı türk ruleti, canlı holdem",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsPage: {
        meta: {
            en: {
                title: "Slot Games | Danobet",
                description: "Join Danobet, the best casino site with the widest slot game variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "Slot Oyunları | Danobet",
                description: "Slot oyunları alanında en çok slot oyun çeşiti ile en iyi casino sitesi olan Danobet'e gelin, canlı casino'daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsBattlePage: {
        meta: {
            en: {
                title: "Slot Battle",
                description: "Slot Battle, first in Turkey",
                keywords: "",
            },
            tr: {
                title: "Slot Battle",
                description: "Slot Battle Türkiye'de ilk",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveCasinoPage: {
        meta: {
            en: {
                title: "Live Slot",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Canlı Slot",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    forgotPassword: {
        meta: {
            en: {
                title: "Forgot Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifremi unuttum",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    resetPassword: {
        meta: {
            en: {
                title: "Reset Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre yenileme",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    changePassword: {
        meta: {
            en: {
                title: "Change Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre Değiştir",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    promoPage: {
        meta: {
            en: {
                title: "Bonuses | Danobet",
                description: "Win with Danobet, the betting site with the highest bonus rates and the lowest wagering requirements!",
                keywords: "bonus, betting bonuses, casino bonuses, bonus sites",
            },
            tr: {
                title: "Bonuslar | Danobet",
                description: "En yüksek oranlı bonuslar ve en düşük çevrim şartına sahip bonus veren bahis sitesi olan Danobet ile kazanın!",
                keywords: "bonus, bahis bonusları, casno bonusları, bonus veren siteler",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    aboutUsPage: {
        meta: {
            en: {
                title: "About Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hakkımızda",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    myAccountPage: {
        meta: {
            en: {
                title: "My Account | Danobet",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hesabım | Danobet",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    betOnGames: {
        meta: {
            en: {
                title: "BetOnGames Live Casino Games | Danobet",
                description:
                    "Join Danobet, the best casino site with the widest BetOnGames live casino and casino variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "BetOnGames Canlı Casino Oyunları | Danobet",
                description:
                    "BetOnGames oyunları ile canlı casino ve casino alanında en çok casino oyun çeşiti ile en iyi casino sitesi olan Danobet'e gelin, canlı casino'daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    twain: {
        meta: {
            en: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            tr: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveGames: {
        meta: {
            en: {
                title: "Bingo | Danobet",
                description: "Join Danobet, the best bingo site with the widest live bingo variety, and win at bingo!",
                keywords: "bingo, live bingo, bingo games, play bingo",
            },
            tr: {
                title: "Tombala | Danobet",
                description: "Canlı tombala alanında en çok tombala oyun çeşiti ile en iyi tombala sitesi olan Danobet'ya gelin, tombala oyunlarında kazanın!",
                keywords: "tombala, canlı tombala, tombala oyunları, tombala oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lottery: {
        meta: {
            en: {
                title: "Lottery | Danobet",
                description: "Play lottery",
                keywords: "lottery, play lottery",
            },
            tr: {
                title: "LOTO | Danobet",
                description: "Loto oyna",
                keywords: "loto, loto oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    tvbet: {
        meta: {
            en: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            tr: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    mailVerify: {
        meta: {
            en: {
                title: "Email Verification",
                description: "",
                keywords: " ",
            },
            tr: {
                title: "E-Posta doğrulama",
                description: " ",
                keywords: " ",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lobbyPage: {
        meta: {
            en: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            // pt: { title: "", description: "", keywords: "" },
            // es: { title: "", description: "", keywords: "" },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
};

export default config;
